/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Warehouse_Queue_DescriptionInputs */

const en_orders_warehouse_queue_description = /** @type {(inputs: Orders_Warehouse_Queue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse queue focused on orders ready to pull.`)
};

const es_orders_warehouse_queue_description = /** @type {(inputs: Orders_Warehouse_Queue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cola de almacen enfocada en pedidos listos para surtir.`)
};

/**
* | output |
* | --- |
* | "Warehouse queue focused on orders ready to pull." |
*
* @param {Orders_Warehouse_Queue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_warehouse_queue_description = /** @type {((inputs?: Orders_Warehouse_Queue_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Warehouse_Queue_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_warehouse_queue_description(inputs)
	return es_orders_warehouse_queue_description(inputs)
});